// docs: https://github.com/altostra/type-validations#readme
import { maybe, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsCatalogsUsageResult = objectOf({
  limits: objectOf({
    catalogs: number,
    file_size: number,
    storage: number,
    filtered_sets_per_catalog: maybe(number),
  }),
  plan: string,
  usage: objectOf({
    catalogs_storage: number,
  }),
});
